export default __webpack_public_path__ + "static/media/Directory.b8a6325c.svg";